export default {
	signup: '/users/sign-up',
	createAccount: '/users/create/new-account',
	getToken: '/auth/token/get',
	revokeToken: '/auth/token/revoke',
	oktaVerify: '/auth/okta/verify',
	okta: '/auth/okta',
};
